import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SortModel } from 'src/components/DataTable';

export interface TaskListFilters {
  searchTerm: string;
  debouncedSearch: string;
  statusFilter: string;
  templateFilter: string;
  kindFilter: 'task' | 'subtask';
  clientFilter: string;
  assigneeFilter: number | null;
  paginationModel: { page: number; pageSize: number };
  taskScope: 'all' | 'my';
  sortModel: SortModel[];
}

const initialState: TaskListFilters = {
  searchTerm: '',
  debouncedSearch: '',
  statusFilter: 'all',
  templateFilter: 'all',
  kindFilter: 'task',
  clientFilter: 'all',
  assigneeFilter: null,
  paginationModel: { page: 0, pageSize: 10 },
  taskScope: 'my',
  sortModel: [{ field: 'createdAt', sort: 'desc' }]
};

const taskListFiltersSlice = createSlice({
  name: 'taskListFilters',
  initialState,
  reducers: {
    setTaskListFilters: (state, action: PayloadAction<Partial<TaskListFilters>>) => {
      return { ...state, ...action.payload };  
    },
    resetTaskListFilters: () => {
      return initialState;                    
    }
  }
});

export const { setTaskListFilters, resetTaskListFilters } = taskListFiltersSlice.actions;
export default taskListFiltersSlice.reducer;

export const selectTaskListFilters = (state: { taskListFilters: TaskListFilters }) =>
  state.taskListFilters;  